<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                  ref="form">
                                <FormItem :label="t.tag.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="20"
                                           :placeholder="msgUtil.placeholderRequired(t.tag.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.tag.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.tag.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.tag.open}}</span>
                                        <span slot="close">{{t.tag.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {add} from '@/api/tag';

    export default {
        name: 'content_tag_add',
        data() {
            const t = this.$_t();
            const msgUtil = this.$msgUtil;
            return {
                self: this,
                t: t,
                msgUtil: msgUtil,
                formItem: {
                    name: '',
                    status: '1',
                    sortOrder: 0,
                },
                ruleValidate: {
                    name: [
                        {
                            required: true,
                            message: msgUtil.errorRequired(t.tag.name),
                            trigger: 'blur',
                        },
                        {
                            type: 'string',
                            max: 20,
                            message: msgUtil.errorMaxLengthFullWidth(t.tag.name, 20),
                            trigger: 'blur',
                        },
                    ],
                    sortOrder: [
                        {
                            required: true,
                            type: 'number',
                            message: msgUtil.errorRequired(t.tag.sortOrder),
                            trigger: 'blur',
                        },
                    ],
                },
                loading: false,
            };
        },
        methods: {
            handleSubmit() {
                this.loading = true;
                this.$Loading.start();
                this.$refs['form'].validate(async valid => {
                    if (valid) {
                        this.loading = true;
                        let tagDto = {};
                        tagDto.name = this.formItem.name;
                        tagDto.status = this.formItem.status;
                        tagDto.sortOrder = this.formItem.sortOrder;
                        await add(tagDto);
                        this.$Message.success(this.msgUtil.message.action.addSuccess);
                        this.$refs.form.resetFields();
                        this.$Loading.finish();
                    } else {
                        this.$Loading.error();
                        this.$Message.error(this.msgUtil.message.action.addFail);
                    }
                });
                this.loading = false;
            },

            handleReset() {
                this.$refs.form.resetFields();
                this.imageList = [];
                this.loading = false;
            },
        },
        mounted() {
        },
    };
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
